export const NOTE_COLORS = [
  '#F5D76E',
  '#FFC9A9',
  '#FFB7C5',
  '#D7B5FF',
  '#AFCBFF',
  '#9FE3D8',
  '#B8E986',
  '#FFD166',
  '#F7A8A8',
  '#C3AED6',
  '#8EC5FC',
  '#A8E6CF',
];

export function normalizeNoteColor(value, fallback = NOTE_COLORS[0]) {
  if (!value || typeof value !== 'string') return fallback;
  const trimmed = value.trim();
  const valid = /^#([0-9a-fA-F]{6})$/.test(trimmed);
  return valid ? trimmed.toUpperCase() : fallback;
}
